import styled from 'styled-components';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import { borderRadius } from '../../../modules/style/defaults';
import { fontSize } from '../../../modules/style/mixins/fontSize';

export const SyntaxStyle = styled(SyntaxHighlighter)`
	background: rgb(13 20 33) !important;
	border: 3px solid rgb(8 35 72) !important;
	border-radius: ${(props) => props.theme.layout.borderRadius}!important;
	box-shadow: unset !important;
	margin: 0 !important;
	padding: 0 !important;
	${fontSize({
		important: true,
		size: '10px',
		sizeDesktop: '12px',
	})};

	code {
		${fontSize({
			important: true,
			size: '10px',
			sizeDesktop: '12px',
		})};
		${borderRadius};
		margin-left: -20px;
		padding: 10px;

		@media (min-width: ${(props) => props.theme.media.minWidthDesktop}) {
			padding: 15px;
		}
	}
`;
